/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ==========================================================================
 * SHL MEGA MENU CONTROLLER  —  v1.0
 * --------------------------------------------------------------------------
 * Handles ONLY the left-rail -> panel swap inside .shl-mega.
 *
 * Opening and closing the mega menu itself is still owned by the theme's
 * DesktopNavigation class in theme.js. This script deliberately does not
 * touch aria-hidden, does not use data-type="menuitem", and does not bind
 * anything DesktopNavigation also binds — so the two never fight.
 *
 * Behaviour:
 *   - Hovering or focusing a rail link swaps the visible panel.
 *   - Clicking a rail link still navigates to that collection (the rail is
 *     made of real links, not tabs — better for crawling and for users who
 *     want the parent category).
 *   - Up/Down arrows move between rail links.
 *   - Every panel resets to the first item when the menu closes, so the
 *     next open is predictable.
 * ========================================================================== */
(function () {
  'use strict';

  var HOVER_DELAY = 60; // ms — absorbs diagonal mouse travel across the rail

  function panelsFor(mega) {
    return Array.prototype.slice.call(mega.querySelectorAll('[data-shl-panel]'));
  }

  function railLinksFor(mega) {
    return Array.prototype.slice.call(mega.querySelectorAll('[data-shl-rail-link]'));
  }

  function activate(mega, link) {
    if (!link || link.classList.contains('is-active')) {
      return;
    }

    var targetId = link.getAttribute('aria-controls');

    railLinksFor(mega).forEach(function (item) {
      var isTarget = item === link;
      item.classList.toggle('is-active', isTarget);
      item.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
    });

    panelsFor(mega).forEach(function (panel) {
      if (panel.id === targetId) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function reset(mega) {
    var first = railLinksFor(mega)[0];
    if (!first) {
      return;
    }

    railLinksFor(mega).forEach(function (item, i) {
      item.classList.toggle('is-active', i === 0);
      item.setAttribute('aria-expanded', i === 0 ? 'true' : 'false');
    });

    panelsFor(mega).forEach(function (panel, i) {
      if (i === 0) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function initMega(mega) {
    if (mega.hasAttribute('data-shl-mega-ready')) {
      return;
    }
    mega.setAttribute('data-shl-mega-ready', '');

    var links = railLinksFor(mega);
    if (links.length === 0) {
      return; // flat layout, nothing to swap
    }

    var hoverTimer = null;

    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
          activate(mega, link);
        }, HOVER_DELAY);
      });

      link.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
      });

      link.addEventListener('focus', function () {
        clearTimeout(hoverTimer);
        activate(mega, link);
      });

      link.addEventListener('keydown', function (event) {
        var index = links.indexOf(link);
        var next = null;

        if (event.key === 'ArrowDown') {
          next = links[index + 1] || links[0];
        } else if (event.key === 'ArrowUp') {
          next = links[index - 1] || links[links.length - 1];
        } else if (event.key === 'Home') {
          next = links[0];
        } else if (event.key === 'End') {
          next = links[links.length - 1];
        }

        if (next) {
          event.preventDefault();
          next.focus();
        }
      });
    });

    // When the theme closes the panel, put it back to its first item.
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.target.getAttribute('aria-hidden') === 'true') {
            reset(mega);
          }
        });
      }).observe(mega, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-shl-mega]').forEach(initMega);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-bind when the theme editor reloads the header section.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-shl-mega]')) {
      initAll();
    }
  });
})();

